<template>
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="confirm()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container class="p-4 text-center">
            <h1 class="m-3 mb-5">Welcome to {{site_name}}</h1>
            <div v-html="welcome.content"></div>
            <template v-if="welcome_text_for_popup">
                <h5 class="mb-5 mt-5">{{welcome_text_for_popup}}</h5>
            </template>
            <div class="cmt-30 mb-5">
                <v-btn color="primary" @click="confirm()">Yes</v-btn>
            </div>

        </v-container>
    </v-card>
</template>

<script>
export default {
    name: "DialogWelcomeText",
    computed: {
        site_name() {
            return this.$store.state.resources.config.site_name;
        },
        welcome() {
            return this.$store.state.resources.policy_and_terms.welcome;
        },
        welcome_text_for_popup() {
            return this.$store.state.resources.config.welcome_text_for_popup;
        },

    },
    methods:{
        confirm(){
            this.$store.dispatch('focusInput', 'secondModalInput');
            this.$emit('modal-close')
        }
    },
}
</script>

<style scoped>
    .min-height-200{
        min-height: 200px;
    }
    .cmt-30{
        margin-top: 70px;
    }
</style>
